<template>
    <div>
        <div class="row" v-if="controls">
            <div class="col">
                <h3 class="sectionTitle">{{ $t('common.generalities.occupants') }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <Stepper
                    :title="$t('common.reservation.numberOfAdults')"
                    v-model="numberOfAdults"
                    :minValue="0"/>
            </div>


            <div class="col-12 col-md-6">
                <Stepper
                    :title="$t('common.reservation.numberOfKids')"
                    v-model="numberOfKids"
                    :minValue="0"/>
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from "@/components/common/Stepper"
export default {
    name: "OccupantsStepper",
    components: {
        Stepper
    },
    props: {
        controls: {
            type: Boolean,
        required: false,
        default: true 
        }
        
    },
    computed: {
        query: function() {
            return this.$store.getters.getQuery
        },
        numberOfKids: {
            get() {
                return this.query.numberOfKids;
            }, set(val) {
                let currentQuery = this.query;
                currentQuery.numberOfKids = val;

                this.$store.commit('setQuery', currentQuery);
            }
        },
        numberOfAdults: {
            get() {
                return this.query.numberOfAdults;
            }, set(val) {
                let currentQuery = this.query;
                currentQuery.numberOfAdults = val;

                this.$store.commit('setQuery', currentQuery);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .sectionTitle {
        margin-top: 12px;
        margin-bottom: 12px;
    }
</style>